// One CSV cell, safe to open in Excel / Google Sheets (security audit
// 2026-10-21, M5 — CSV injection). A cell that starts with = + - @ (or a tab /
// carriage return) is read by a spreadsheet as a FORMULA, so a client name
// like `=HYPERLINK("http://evil",…)` typed into Flow would run on the
// finance team's machine. Such cells get a leading ' (shown as text).
// Plain numbers (incl. negatives like -12.50) are left alone so sums work.
// Pure — the offline gate executes it.

const FORMULA_START = /^[=+\-@\t\r]/;
const PLAIN_NUMBER = /^-?\d+(\.\d+)?$/;

export function csvCell(value: string | number | null | undefined): string {
  let s = value === null || value === undefined ? "" : String(value);
  if (FORMULA_START.test(s) && !PLAIN_NUMBER.test(s)) s = `'${s}`;
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
